<template>
  <div class="app-wrap">
    <header id='header'>
      <div class='inner'>
        <div class='col col1'>
          <a class='btnNavi prev'>
            <span @click.stop.prevent='backBtn' class='ico'>이전</span>
          </a>
        </div>
        <div class='col col2'>
          <h1>{{$t(`${'MyPage.myMenu'}`)}}</h1>
        </div>
      </div>
    </header>
    <div>
      <div class="myMenuCount">총 <span>{{ count }}</span>개</div>
    </div>
    <div v-if="myMenuLength > 0">
      <div v-for="(menu, index) in myMenus" :key="index" >
        <div class="myMenuList" @click="storeIntroUrl(menu)">
          <!-- <div class="myMenuListText">
            <h2>{{menu.storeName}}</h2>
            <p>{{menu.name}}</p>
          </div>
          <div class="myMenuListImg">
            <img :src="menu.originalImagePath" v-if="menu.originalImagePath">
            <img src="@/assets/img/menu_img_empty.png" v-else>
          </div>
          <div class="myMenuListDel">
            <img src="@/assets/img/ic_delete_36.png" @click.stop="deleteMyMenu(menu)">
          </div> -->
          <div class="myMenuLeft">
            <div class="myMenuTxt goodsList">
              <div class='name'>
                <MenuName :menu='menu'>
                  <span class='menuName'>{{menu.name}}</span>
                </MenuName>
              </div>
              <div :class='menu.soldOutTodayFlag ? "price disabled" : "price"'>
                <span class='num'>
                  <em>{{formatComma(menu.price)}}</em><em class='won'>{{$t('MoneyUnit')}}</em>
                </span>
                <span v-if='menu.soldOutTodayFlag' class='tag'>
                  {{$t(menu.deleteMenuFlag ? 'soldOut2' : menu.soldOutTodayFlag ? 'soldOut' : 'soldOut3')}}
                </span>
              </div>
            </div>
            <div class="myMenuImg" v-if="menu.imagePath">
              <img :src="menu.imagePath">
              <!-- <img src="@/assets/img/menu_img_empty.png" v-else> -->
            </div>
          </div>
          <div class="myMenuRight">
            <img src="@/assets/img/ic_delete_36.png" @click.stop="deleteMyMenu(menu)">
          </div>
        </div>
      </div>
    </div>
    <div class="noMenu" v-else>
      <img src="../assets/img/ic_error_36.png" >
      <p>관심상품에 담긴 상품이 없습니다</p>
    </div>
  </div>
</template>

<script>
import MenuName from '@/components/Common/MenuName.vue'
import service from '@/backend/modnpay_app_api'
export default {
  components: { MenuName },
  data () {
    return {
      type: '',
      myMenus: {},
      menuCode: '',
      count: 0
    }
  },

  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
    this.init()
  },

  computed: {
    myMenuLength () { return this.myMenus ? this.myMenus.length : 0 } // 배달비 정보
  },
  methods: {
    backBtn () {
      history.back()
    },
    init () {
      this.type = 1
      this.myMenu()
    },
    deleteMyMenu (menu) {
      this.type = 3
      this.menuCode = menu.code
      this.myMenu()
    },
    async storeIntroUrl (menu) {
      const req = {
        urlCode: menu.storeGroupCode,
        introUrlType: menu.qrType
      }
      const { data } = await service.storeIntroUrl(req)
      localStorage.setItem('pageType', 2)
      localStorage.setItem('menuCode', menu.code)
      sessionStorage.removeItem('tradition')
      sessionStorage.removeItem('categoryCode')
      sessionStorage.removeItem('addressByLotNum')
      sessionStorage.removeItem('time')
      window.location.href = data.introUrl
    },
    async myMenu () {
      const req = {
        type: this.type, // 1:리스트 2:추가 3:삭제
        menuCode: this.menuCode
      }
      const { data } = await service.myMenu(req)
      if (data.resultCode == 0) {
        this.myMenus = data.myMenus
        this.count = data.totalCount
        if (this.type === 3) {
          this.init()
        }
      }
    }
  }
}
</script>

<style scoped>
.noMenu{
  height: calc(100% - 32px);
}
</style>
